import { ApiError } from '../types';

export const createError = (message: string, code?: string, status?: number): ApiError => ({
  message,
  code,
  status,
});

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return 'An unexpected error occurred';
};

